import React, { FunctionComponent } from 'react';
// Relative (not `components/shared/Styles`) on purpose: the jest config's baseUrl/moduleNameMapper
// doesn't resolve the tsconfig absolute alias for this module, so an absolute import breaks the
// jest mount. Do not "tidy" this back to absolute.
import { FocusShadowHyperlink } from '../shared/Styles';
import { AppCardFooter } from '../shared';

interface Props {
  zip: string | null;
  showSkipLink?: boolean;
  // When provided (coverage-check flow), Skip navigates here instead of `/skip-benefit?zip=`.
  skipHref?: string;
  // Coverage-check flow suppresses the "I don't have coverage" escape link. Defaults to shown.
  coverageFlow?: boolean;
  onSkip(): void;
  onNoCoverage(): void;
}

const SkipFooter: FunctionComponent<Props> = ({
  zip,
  showSkipLink = true,
  skipHref,
  coverageFlow = false,
  onSkip,
  onNoCoverage,
}: Props) => (
  <AppCardFooter>
    {zip && !coverageFlow && (
      <FocusShadowHyperlink
        data-testid="noCoverageLink"
        href={`/affiliation-coverage?zip=${zip}`}
        pb="sm"
        onClick={() => onNoCoverage()}
        data-track-event
        data-track={JSON.stringify({
          controlName: 'no-coverage-link',
          controlText: "I don't have coverage",
        })}
      >
        I don&apos;t have coverage
      </FocusShadowHyperlink>
    )}
    {showSkipLink && (
      <FocusShadowHyperlink
        id="skipFooter"
        href={skipHref || `/skip-benefit?zip=${zip || ''}`}
        onClick={() => onSkip()}
        data-track-event
        data-track={JSON.stringify({
          controlName: 'skip-coverage-link',
          controlText: 'Skip (You can add coverage later)',
        })}
      >
        Skip (You can add coverage later)
      </FocusShadowHyperlink>
    )}
  </AppCardFooter>
);

export default SkipFooter;
